import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@components/atoms/typography';
import { useAppSelector } from '@store';
import { getImageUrl } from '@utils/get-image-url';

import { Timer } from '../start/timer';

import { ExpiredStepContainer } from './styles';

export const ExpiredStep: React.FC = () => {
    const { t } = useTranslation();

    const isCustomPartner = useAppSelector(
        (state) => state.docsVerification.sdkOptions?.customPartner?.concordium,
    );

    return (
        <ExpiredStepContainer>
            <Timer />
            <img
                src={getImageUrl('/images/sdk/verification/time-expired.png')}
                alt='Time expired'
                className='expired-icon'
            />
            <Typography tag='h2' variant='h2' className='title'>
                {t('docVerificationWidget.expired.title')}
            </Typography>
            {isCustomPartner ? (
                <React.Fragment>
                    <Typography tag='div' variant='text' color='text-light' className='sub-title'>
                        {t('docVerificationWidget.expired.subTitleConcordium')}
                    </Typography>
                    <Typography tag='div' variant='text' color='text-light' className='sub-title'>
                        {t('docVerificationWidget.expired.noticeConcordium')}
                    </Typography>
                </React.Fragment>
            ) : (
                <Typography tag='div' variant='text' color='text-light' className='sub-title'>
                    {t('docVerificationWidget.expired.subTitle')}
                </Typography>
            )}
        </ExpiredStepContainer>
    );
};
